export var iconChevronSmall90 = {
  "children": [{
    "name": "path",
    "type": "element",
    "value": "",
    "attributes": {
      "fill": "currentColor",
      "d": "M4.975 2.75a.748.748 0 0 1 1.281-.53l5.25 5.264a.75.75 0 0 1 0 1.06L6.283 13.78a.75.75 0 1 1-1.062-1.06l4.695-4.706L5.194 3.28a.75.75 0 0 1-.219-.53"
    },
    "children": []
  }],
  "id": "icon-chevron-small-90",
  "viewBox": "0 0 16 16"
};